export const getRequestId = state => state.search.diagnostics.requestId;
